import { createTheme} from "@mui/material"
import { esES } from '@mui/material/locale';

export const theme = createTheme({
    palette:{
        
        secondary: {
            main: "#15c630",
        },
        warningColor: {
            main: "#892349",
            light: "#464892",
        },
   },

   buttonStep: {
    width: "150px",
    height: "49px",
    backgroundImage: "linear-gradient(.25turn, #f00, #00f)"
  },
  esES,
})